import { db } from '@config/firebaseConfig';
import { doc, getDoc, updateDoc, increment, arrayUnion, arrayRemove } from 'firebase/firestore';

/**
 * Toggles like for a product. One like per userId (reviewerId).
 * @param {string} productId
 * @param {string} userId - dulceReviewerId from localStorage
 * @param {boolean} isCurrentlyLiked
 */
export const toggleProductLike = async (productId, userId, isCurrentlyLiked) => {
    if (!productId || !userId) {
        throw new Error('productId y userId son requeridos');
    }

    const productRef = doc(db, 'products', productId);
    const snap = await getDoc(productRef);

    if (!snap.exists()) {
        throw new Error('Producto no encontrado');
    }

    const likedBy = snap.data().liked_by || [];
    const isInList = likedBy.includes(userId);

    if (isCurrentlyLiked) {
        if (!isInList) {
            return false;
        }

        await updateDoc(productRef, {
            liked_by: arrayRemove(userId),
            likes_count: increment(-1),
        });
        return false;
    }

    if (isInList) {
        return true;
    }

    await updateDoc(productRef, {
        liked_by: arrayUnion(userId),
        likes_count: increment(1),
    });

    return true;
};
